import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

import RoomHeader from './components/headers/RoomHeader';
import CreateForm from './components/forms/CreateForm';
import useApiControl from './common/useApiControl';
import { canCreateOwnerRoom, getOwnerRoomCreateDeniedMessage } from './common/ownerRoomPermission';



const CreateRoom = () => {
    const [user, setUser] = useState(null);
    const canCreateRoom = canCreateOwnerRoom(user);

    //user
    const { data: userData, executeRequest: fetchUser } = useApiControl({
        action: '/get_user',
        method: 'POST',
    });

    useEffect(() => {
        fetchUser().catch((error) => {
            console.error(error);
        });
    }, [fetchUser]);

    useEffect(() => {
        if (userData) {
            setUser(userData);
        }
    }, [userData]);

    return (
        <Box sx={{ width: '100%' }}>
            <RoomHeader user={user} />
            {user === null ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            ) : canCreateRoom ? (
                <CreateForm user={user} />
            ) : (
                <Box sx={{ maxWidth: 720, mx: 'auto', mt: 3, px: 2 }}>
                    <Alert severity="error">
                        {getOwnerRoomCreateDeniedMessage(user)}
                    </Alert>
                </Box>
            )}
        </Box>
    );
};

export default CreateRoom;
